import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import adConfig from '../../lib/advertising/slots/ros-bottom-banner';
import { getCurrentClubIncludesAdverts } from '../../store/clubs/selectors';
import Advert from './advert';
import ServeAdButler from './serve-adbutler';

const RosBottomBanner = ({ className, includeAdverts, style: customStyle, uid }) => {
  const [showFallback, setShowFallback] = useState(false);
  const adId = 716968;
  const adProps = {};
  if (uid) {
    adProps.key = uid;
  }

  const handleAdError = () => {
    setShowFallback(true);
  };

  if (!includeAdverts) {
    return null;
  }

  if (showFallback) {
    const holderStyle = {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      backgroundColor: '#fff',
    };

    const adUid = (Math.random() + 1).toString(36).substring(7);
    return (
      <div style={holderStyle}>
        <ServeAdButler id={adId} uid={adUid} />
      </div>
    );
  }

  return (
    <Advert
      adConfig={adConfig}
      className={className}
      style={customStyle}
      onError={handleAdError}
      {...adProps}
    />
  );
};

RosBottomBanner.propTypes = {
  className: PropTypes.string,
  includeAdverts: PropTypes.bool.isRequired,
  style: PropTypes.shape(),
  uid: PropTypes.string,
};

RosBottomBanner.defaultProps = {
  className: null,
  style: {},
  uid: null,
};

const mapStateToProps = (state) => ({
  includeAdverts: getCurrentClubIncludesAdverts(state),
});

export default connect(mapStateToProps)(RosBottomBanner);
